// Behavior-level. No source list, refresh-cron, scoring, or table internals.

export default {
  title: 'Industry Pulse',
  summary:
    'A running feed of AdTech news from major industry publishers — filter by topic or source, see what\u2019s trending, search, and bookmark articles for later.',

  sections: [
    {
      h: 'What this tool does',
      p: [
        'Aggregates recent articles from a set of AdTech publishers and refreshes through the day.',
        'You can filter by topic, by source, and to trending or featured only, search titles and summaries, and bookmark articles to a personal list.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        'A quick daily scan of what\u2019s moving in the industry without checking a dozen sites.',
        'Keeping a few pieces to read later, or tracking a specific topic such as CTV or privacy.',
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Scan the feed** — newest first, with the freshest items badged.',
        '**Filter** by topic chip or source, or flip to trending / featured only.',
        '**Search** a keyword across titles and summaries.',
        '**Bookmark** anything worth keeping; the bookmarks view collects them.',
      ],
    },
    {
      callout:
        'Articles link out to the original publisher — the feed is for discovery and triage, so the full piece always opens on the source site.',
    },
  ],

  faqs: [
    {
      q: 'How fresh is it?',
      a: 'The feed refreshes through the day, so new pieces appear on their own. The nav icon badges when there are fresh items you haven\u2019t seen.',
    },
    {
      q: 'The topic counts look short.',
      a: 'The topic chips count articles from a recent rolling window, so a quiet topic shows fewer even if it has older pieces further back.',
    },
  ],
};
